import { useEffect } from "react";
import { useDodgeButton } from "@/hooks/useDodgeButton";

export function ResumeModal({ games }) {
  const { resumeModalOpen, closeResumeModal, confirmResume } = games;

  const { containerRef, buttonRef, handlePointerMove } = useDodgeButton({
    enabled: resumeModalOpen,
    initialPos: { x: 160, y: 8 },
  });

  useEffect(() => {
    if (!resumeModalOpen) return undefined;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [resumeModalOpen]);

  if (!resumeModalOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-ink/60 p-5"
      onClick={closeResumeModal}
      onPointerMove={handlePointerMove}
      role="dialog"
      aria-modal="true"
      aria-labelledby="resume-modal-title"
    >
      <div
        className="relative w-full max-w-[440px] rounded-3xl border-3 border-ink bg-cream p-10 shadow-neo-lg"
        onClick={(e) => e.stopPropagation()}
        onPointerMove={handlePointerMove}
      >
        <h3 id="resume-modal-title" className="mb-3 font-display text-2xl text-ink">
          Hold up ✋
        </h3>
        <p className="mb-5 text-[15px] leading-relaxed text-muted">
          Before you grab my resume, promise you&apos;ll actually read it and reach out. No
          ghosting.
        </p>

        <div
          ref={containerRef}
          className="relative h-[160px] w-full touch-none select-none"
          onPointerMove={handlePointerMove}
        >
          <button
            type="button"
            onClick={confirmResume}
            className="absolute left-0 top-0 z-10 cursor-pointer rounded-xl border-3 border-ink bg-green px-[22px] py-3 font-display text-[15px] text-ink"
          >
            I promise 🤝
          </button>

          <div
            ref={buttonRef}
            role="presentation"
            aria-hidden
            className="pointer-events-none absolute left-0 top-0 z-20 whitespace-nowrap rounded-xl border-3 border-ink bg-white px-[22px] py-3 font-display text-[15px] text-ink will-change-transform"
            style={{ transform: "translate3d(160px, 8px, 0)" }}
          >
            Nah, maybe later
          </div>
        </div>
      </div>
    </div>
  );
}
